const rankingItems = [
  { rank: 1, title: '星际征途：新纪元', tag: '科幻', hot: '9.8', trend: 'up', desc: '史诗级太空冒险，视觉震撼' },
  { rank: 2, title: '暗夜追踪', tag: '动作', hot: '9.6', trend: 'up', desc: '极限追凶，全程高能无尿点' },
  { rank: 3, title: '遇见你的夏天', tag: '爱情', hot: '9.5', trend: 'up', desc: '年度最暖心动漫爱情故事' },
  { rank: 4, title: '风云再起', tag: '武侠', hot: '9.3', trend: 'stable', desc: '江湖恩怨，侠义豪情' },
  { rank: 5, title: '末日孤舰：重生', tag: '灾难', hot: '9.1', trend: 'down', desc: '绝境求生，人性考验' },
  { rank: 6, title: '梦境奇缘', tag: '动画', hot: '8.9', trend: 'up', desc: '奇幻冒险，唤醒童真' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热映榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            本周最受欢迎的电影排行，看看大家都在看什么
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-5 py-4 md:px-8 md:py-5 transition-colors hover:bg-background-100/60 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div
                className={`w-9 h-9 md:w-10 md:h-10 flex-shrink-0 flex items-center justify-center rounded-xl font-bold text-sm md:text-base ${
                  item.rank === 1
                    ? 'bg-primary-500 text-foreground-950'
                    : item.rank === 2
                    ? 'bg-secondary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-accent-400 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium flex-shrink-0 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">{item.desc}</p>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                <i
                  className={`text-sm ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-fill text-accent-500'
                      : item.trend === 'down'
                      ? 'ri-arrow-down-fill text-foreground-400'
                      : 'ri-subtract-line text-foreground-400'
                  }`}
                ></i>
                <span className="text-sm font-bold text-primary-600 whitespace-nowrap">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}